import { render, staticRenderFns } from "./CallCentreDisplay.vue?vue&type=template&id=08af7bf5&"
import script from "./CallCentreDisplay.vue?vue&type=script&lang=js&"
export * from "./CallCentreDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports